import { render, staticRenderFns } from "./MitMenuAdmin.vue?vue&type=template&id=4ece8016&scoped=true"
import script from "./MitMenuAdmin.vue?vue&type=script&lang=js"
export * from "./MitMenuAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ece8016",
  null
  
)

export default component.exports